import { render, staticRenderFns } from "./OVersionCards.vue?vue&type=template&id=84517c32&scoped=true&"
import script from "./OVersionCards.vue?vue&type=script&lang=js&"
export * from "./OVersionCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84517c32",
  null
  
)

export default component.exports